const hfEnvironmentName = () => $('#hfEnvironmentName');

export const environmentName = <string>hfEnvironmentName().val();
